import React from "react";
import Box from "react-raster";
import { Eyebrow, H3 } from "../Typography";
import Container, { getGridBottomFromContent } from "../Container";

function ComponentGroupHeading({ eyebrow, title, bottomSpacing }) {
  return (
    <Container
      marginBottom={getGridBottomFromContent(bottomSpacing)}
      gridRowGap={0}
    >
      <Box>
        <Eyebrow colour="blue" marginTop="-16px">
          {eyebrow}
        </Eyebrow>
      </Box>
      <Box cols={[6, 8, 6]}>
        <H3>{title}</H3>
      </Box>
    </Container>
  );
}

export default ComponentGroupHeading;
